
export enum RequestFileKeyEnum {
    App_MyProfile_ProfilePicture = "App_MyProfile_ProfilePicture",
    App_UpdateCompany_LogoImage = "App_UpdateCompany_LogoImage",
    App_UpdateCompany_CoverImage = "App_UpdateCompany_CoverImage",
    Admin_PostCoverImage = "Admin_PostCoverImage",
}

export enum RequestBodyKeyEnum {
    Auth_User_Login_Email = "Auth_User_Login_Email",
    Auth_User_Login_Password = "Auth_User_Login_Password",
    Auth_User_Register_Email = "Auth_User_Register_Email",
    Auth_User_Register_Password = "Auth_User_Register_Password",
    Auth_User_Register_PasswordConfirmation = "Auth_User_Register_PasswordConfirmation",
    Auth_User_Register_FirstName = "Auth_User_Register_FirstName",
    Auth_User_Register_LastName = "Auth_User_Register_LastName",
    Auth_User_Register_BrowserTimeZone = "Auth_User_Register_BrowserTimeZone",
    Auth_User_PasswordReset_Email = "Auth_User_PasswordReset_Email",
    Auth_User_NewPassword_Token = "Auth_User_NewPassword_Token",
    Auth_User_NewPassword_Password = "Auth_User_NewPassword_Password",
    Auth_User_NewPassword_PasswordConfirmation = "Auth_User_NewPassword_PasswordConfirmation",
    App_UpdatePassword_CurrentPassword = "App_UpdatePassword_CurrentPassword",
    App_UpdatePassword_NewPassword = "App_UpdatePassword_NewPassword",
    App_UpdatePassword_NewPasswordConfirmation = "App_UpdatePassword_NewPasswordConfirmation",
    App_MyProfile_FirstName = "App_MyProfile_FirstName",
    App_MyProfile_LastName = "App_MyProfile_LastName",
    App_MyProfile_DisplayTimezone = "App_MyProfile_DisplayTimezone",
    App_Integration_Name = "App_Integration_Name",
    App_Integration_GoogleCalendar_ShouldCheckGoogleCalendarForConflicts = "App_Integration_GoogleCalendar_ShouldCheckGoogleCalendarForConflicts",
    App_Integration_OutlookCalendar_ShouldCheckOutlookCalendarForConflicts = "App_Integration_OutlookCalendar_ShouldCheckOutlookCalendarForConflicts",
    App_Integration_GoogleAnalytics_Tag = "App_Integration_GoogleAnalytics_Tag",
    App_Integration_MetaPixel_PixelId = "App_Integration_MetaPixel_PixelId",
    App_AnalyticsEvents_EventName = "App_AnalyticsEvents_EventName",
    App_AnalyticsEvents_SourceType = "App_AnalyticsEvents_SourceType",
    App_AnalyticsEvents_Surface = "App_AnalyticsEvents_Surface",
    App_AnalyticsEvents_ServiceId = "App_AnalyticsEvents_ServiceId",
    App_Availability_TimeZone = "App_Availability_TimeZone",
    App_Onboarding_Industry = "App_Onboarding_Industry",
    App_Onboarding_NumberOfEmployees = "App_Onboarding_NumberOfEmployees",
    App_Onboarding_BookingReason = "App_Onboarding_BookingReason",
    App_Onboarding_BookingReasonDescription = "App_Onboarding_BookingReasonDescription",
    App_Onboarding_PreDefinedAvailabilityType = "App_Onboarding_PreDefinedAvailabilityType",
    App_Onboarding_PreviousSchedulingTool = "App_Onboarding_PreviousSchedulingTool",
    App_Onboarding_WebsiteUrl = "App_Onboarding_WebsiteUrl",
    App_CompanyUser_IsEnabled = "App_CompanyUser_IsEnabled",
    App_CompanyUser_Role = "App_CompanyUser_Role",
    App_BookingFormTheme_MainBackgroundColor = "App_BookingFormTheme_MainBackgroundColor",
    App_BookingFormTheme_MainBackgroundShade = "App_BookingFormTheme_MainBackgroundShade",
    App_BookingFormTheme_MainTextColor = "App_BookingFormTheme_MainTextColor",
    App_BookingFormTheme_MainTextShade = "App_BookingFormTheme_MainTextShade",
    App_CompanyUserInvite_Email = "App_CompanyUserInvite_Email",
    App_UpdateCompany_DisplayName = "App_UpdateCompany_DisplayName",
    App_UpdateCompany_Slug = "App_UpdateCompany_Slug",
    App_UpdateCompany_ShowCompanyDisplayName = "App_UpdateCompany_ShowCompanyDisplayName",
    App_UpdateCompany_ShowCompanyLogo = "App_UpdateCompany_ShowCompanyLogo",
    App_UpdateCompany_ShowCompanyCover = "App_UpdateCompany_ShowCompanyCover",
    App_UpdateCompany_CoverImagePosition = "App_UpdateCompany_CoverImagePosition",
    App_DeleteCompany_Reason = "DeleteCompanyReason",
    App_Company_EmbedButtonSettings_BackgroundColor = "App_Company_EmbedButtonSettings_BackgroundColor",
    App_Company_EmbedButtonSettings_TextColor = "App_Company_EmbedButtonSettings_TextColor",
    App_Company_EmbedButtonSettings_TextContent = "App_Company_EmbedButtonSettings_TextContent",
    App_Company_EmbedButtonSettings_FontWeight = "App_Company_EmbedButtonSettings_FontWeight",
    App_Company_EmbedButtonSettings_FontSize = "App_Company_EmbedButtonSettings_FontSize",
    App_Company_EmbedButtonSettings_BorderRadius = "App_Company_EmbedButtonSettings_BorderRadius",
    App_Company_EmbedButtonSettings_ShowIcon = "App_Company_EmbedButtonSettings_ShowIcon",
    App_Company_EmbedButtonSettings_DestinationUrl = "App_Company_EmbedButtonSettings_DestinationUrl",
    App_Company_InPersonHostDefinedMeetingLocation_Id = "App_Company_InPersonHostDefinedMeetingLocation_Id",
    App_Company_InPersonHostDefinedMeetingLocation_Address = "App_Company_InPersonHostDefinedMeetingLocation_Address",
    App_Company_InPersonHostDefinedMeetingLocation_GoogleMapsUrl = "App_Company_InPersonHostDefinedMeetingLocation_GoogleMapsUrl",
    CookieConsent_Functional = "CookieConsent_Functional",
    CookieConsent_Analytics = "CookieConsent_Analytics",
    CookieConsent_Marketing = "CookieConsent_Marketing",
    PostSlug = "postSlug",
    PostTitle = "postTitle",
    PostExcerpt = "postExcerpt",
    PostContent = "postContent",
    PostCoverImageAttributionText = "postCoverImageAttributionText",
    PostCoverImageAttributionLink = "postCoverImageAttributionLink",
    PostPrivateNotes = "postPrivateNotes",
    TurnstileResponse = "cf-turnstile-response",
    HoneyPot_Company = "company",
    App_UpdateService_Slug = "App_UpdateService_Slug",
    App_UpdateService_Title = "App_UpdateService_Title",
    App_UpdateService_Description = "App_UpdateService_Description",
    App_UpdateService_EnabledMeetingLocationIds = "App_UpdateService_EnabledMeetingLocationIds",
    App_UpdateService_DurationInMinutes = "App_UpdateService_DurationInMinutes",
    App_UpdateService_IntervalBetweenMeetings = "App_UpdateService_IntervalBetweenMeetings",
    App_UpdateService_MinimumBookingHoursInAdvance = "App_UpdateService_MinimumBookingHoursInAdvance",
    App_UpdateService_MaximumBookingDaysInAdvance = "App_UpdateService_MaximumBookingDaysInAdvance",
    App_UpdateService_MinimumCancelationHoursInAdvance = "App_UpdateService_MinimumCancelationHoursInAdvance",
    App_UpdateService_IsEnabled = "App_UpdateService_IsEnabled",
    App_UpdateService_IsVisible = "App_UpdateService_IsVisible",
    App_UpdateService_IsPaymentRequired = "App_UpdateService_IsPaymentRequired",
    App_UpdateService_IntegrationId = "App_UpdateService_IntegrationId",
    App_UpdateService_SchedulingStrategy = "App_UpdateService_SchedulingStrategy",
    App_UpdateService_MaximumNumberOfSeatsPerMeeting = "App_UpdateService_MaximumNumberOfSeatsPerMeeting",
    App_UpdateService_EnabledCompanyUsers = "App_UpdateService_EnabledCompanyUsers",
    App_UpdateService_EnabledCompanyUsers_CompanyUserId = "App_UpdateService_EnabledCompanyUsers_CompanyUserId",
    App_UpdateService_EnabledCompanyUsers_IsEnabled = "App_UpdateService_EnabledCompanyUsers_IsEnabled",
    App_UpdateService_Prices_Amount = "App_UpdateService_Prices_Amount",
    App_UpdateService_Prices_Currency = "App_UpdateService_Prices_Currency",
    App_UpdateService_CustomFields_Type = "App_UpdateService_CustomFields_Type",
    App_UpdateService_CustomFields_Title = "App_UpdateService_CustomFields_Title",
    App_UpdateService_CustomFields_Description = "App_UpdateService_CustomFields_Description",
    App_UpdateService_CustomFields_InternalName = "App_UpdateService_CustomFields_InternalName",
    App_UpdateService_CustomFields_IsEnabled = "App_UpdateService_CustomFields_IsEnabled",
    App_UpdateService_CustomFields_IsRequired = "App_UpdateService_CustomFields_IsRequired",
    App_UpdateService_CustomFields_Settings = "App_UpdateService_CustomFields_Settings",
    App_UpdateService_OverlappingAvailabilityId = "App_UpdateService_OverlappingAvailabilityId",
    App_UpdateService_RecurrenceSettings_FrequencyType = "App_UpdateService_RecurrenceSettings_FrequencyType",
    App_UpdateService_RecurrenceSettings_MaximumNumberOfRecurringMeetings = "App_UpdateService_RecurrenceSettings_MaximumNumberOfRecurringMeetings",
    App_UpdateService_RecurrenceSettings_SkipDatesWithNoAvailability = "App_UpdateService_RecurrenceSettings_SkipDatesWithNoAvailability",
    App_UpdateService_RecurrenceSettings_AllowCustomNumberOfRecurringMeetings = "App_UpdateService_RecurrenceSettings_AllowCustomNumberOfRecurringMeetings",
    App_UpdateService_GroupSchedulingSettings_IsMultiSeatAllowed = "App_UpdateService_GroupSchedulingSettings_IsMultiSeatAllowed",
    App_UpdateService_GroupSchedulingSettings_MaximumNumberOfSeatsPerAttendee = "App_UpdateService_GroupSchedulingSettings_MaximumNumberOfSeatsPerAttendee",
    App_Automation_Store_ActionType = "App_Automation_Store_ActionType",
    App_Automation_Store_TriggerType = "App_Automation_Store_TriggerType",
    App_Automation_Update_Name = "App_Automation_Update_Name",
    App_Automation_Update_State = "App_Automation_Update_State",
    App_Automation_Update_TriggerData_TimeAmount = "App_Automation_Update_TriggerData_TimeAmount",
    App_Automation_Update_TriggerData_ServiceIds = "App_Automation_Update_TriggerData_ServiceIds",
    App_Automation_Update_TriggerData_TriggerForAllServices = "App_Automation_Update_TriggerData_TriggerForAllServices",
    App_Automation_Update_ActionData_AllowedCountries = "App_Automation_Update_ActionData_AllowedCountries",
    App_Automation_Update_ActionData_SendToAllCountries = "App_Automation_Update_ActionData_SendToAllCountries",
    App_CompanyUser_Availability_Id = "App_CompanyUser_Availability_Id",
    App_CompanyUser_Services_Ids = "App_CompanyUser_Services_Ids",
    App_Availability_Name = "App_Availability_Name",
    App_Availability_WeekhlyHours = "App_Availability_WeekhlyHours",
    App_Availability_WeekhlyHour_DayOfWeek = "App_Availability_WeekhlyHour_DayOfWeek",
    App_Availability_WeekhlyHour_TimeRanges = "App_Availability_WeekhlyHour_TimeRanges",
    App_Availability_WeekhlyHour_TimeRange_StartAt = "App_Availability_WeekhlyHour_TimeRange_StartAt",
    App_Availability_WeekhlyHour_TimeRange_EndAt = "App_Availability_WeekhlyHour_TimeRange_EndAt",
    App_Availability_DateSpecificHours = "App_Availability_DateSpecificHours",
    App_Availability_DateSpecificHour_StartDate = "App_Availability_DateSpecificHour_StartDate",
    App_Availability_DateSpecificHour_EndDate = "App_Availability_DateSpecificHour_EndDate",
    App_Availability_DateSpecificHour_TimeRanges = "App_Availability_DateSpecificHour_TimeRanges",
    App_Availability_DateSpecificHour_TimeRange_StartAt = "App_Availability_DateSpecificHour_TimeRange_StartAt",
    App_Availability_DateSpecificHour_TimeRange_EndAt = "App_Availability_DateSpecificHour_TimeRange_EndAt",
    App_Availability_AiPrompt = "App_Availability_AiPrompt",
    RescheduleMeeting_TimeZone = "RescheduleMeeting_TimeZone",
    RescheduleMeeting_DateForScheduling = "RescheduleMeeting_DateForScheduling",
    RescheduleMeeting_TimeSlotStartForScheduling = "RescheduleMeeting_TimeSlotStartForScheduling",
    RescheduleMeeting_TimeSlotEndForScheduling = "RescheduleMeeting_TimeSlotEndForScheduling",
    ScheduleMeeting_ServicePriceId = "ScheduleMeeting_ServicePriceId",
    ScheduleMeeting_MeetingLocationId = "ScheduleMeeting_MeetingLocationId",
    ScheduleMeeting_PhoneNumber = "ScheduleMeeting_PhoneNumber",
    ScheduleMeeting_PhoneCountryCode = "ScheduleMeeting_PhoneCountryCode",
    ScheduleMeeting_InPersonAttendeeDefinedMeetingLocationAddress = "ScheduleMeeting_InPersonAttendeeDefinedMeetingLocationAddress",
    ScheduleMeeting_Notes = "ScheduleMeeting_Notes",
    ScheduleMeeting_CustomerName = "ScheduleMeeting_CustomerName",
    ScheduleMeeting_CustomerEmail = "ScheduleMeeting_CustomerEmail",
    ScheduleMeeting_CustomFieldResponses = "ScheduleMeeting_CustomFieldResponses",
    ScheduleMeeting_NumberOfRecurringMeetingsToSchedule = "ScheduleMeeting_NumberOfRecurringMeetingsToSchedule",
    ScheduleMeeting_NumberOfRequestedSeats = "ScheduleMeeting_NumberOfRequestedSeats",
    ScheduleMeeting_SavePaymentMethod = "ScheduleMeeting_SavePaymentMethod",
    ScheduleMeeting_Stripe_ConfirmationToken = "ScheduleMeeting_Stripe_ConfirmationToken",
    ScheduleMeeting_PayPal_OrderId = "ScheduleMeeting_PayPal_OrderId",
    Customer_Auth_Login_Email = "Customer_Auth_Login_Email",
    Customer_Auth_Login_Password = "Customer_Auth_Login_Password",
    Customer_PasswordReset_Email = "Customer_PasswordReset_Email",
    Customer_NewPassword_Password = "Customer_NewPassword_Password",
    Customer_NewPassword_PasswordConfirmation = "Customer_NewPassword_PasswordConfirmation",
    FreeTool_BusinessNameGenerator_Description = "FreeTool_BusinessNameGenerator_Description",
    FreeTool_BusinessNameGenerator_BrowserTimezone = "FreeTool_BusinessNameGenerator_BrowserTimezone",
}

export enum RouteParamKeyEnum {
    CompanySlug = "companySlug",
    ServiceSlug = "serviceSlug",
    PostSlug = "postSlug",
    CategorySlug = "categorySlug",
    ArticleSlug = "articleSlug",
    BusinessNameSuggestionId = "businessNameSuggestionId",
}

export enum RequestQueryKeyEnum {
    PaginationPage = "page",
    PaginationPerPage = "perPage",
    DestinationUrl = "destination",
    Locale = "locale",
    Markdown = "markdown",
    Admin_Queue_JobId = "Admin_Queue_JobId",
    Admin_Queue_JobState = "Admin_Queue_JobState",
    Admin_Queue_QueueName = "Admin_Queue_QueueName",
    Admin_Users_Search = "Admin_Users_Search",
    PostId = "post",
    SkipPublishedAtCheck = "skipPublishedAtCheck",
    OAuth_Code = "code",
    OAuth_State = "state",
    OAuth_Scope = "scope",
    OAuth_AuthenticationAction = "authenticationAction",
    App_Billing_FeatureType = "App_Billing_FeatureType",
    App_Billing_FeatureQuantity = "App_Billing_FeatureQuantity",
    Auth_User_EmailVerificationToken = "Auth_User_EmailVerificationToken",
    Auth_User_PasswordResetToken = "Auth_User_PasswordResetToken",
    CompanyId = "company",
    CompanyUserId = "companyUser",
    PlanId = "plan",
    InviteId = "invite",
    IntegrationId = "integration",
    LegacyOrderId = "order",
    MeetingId = "meeting",
    ReservationId = "reservation",
    AttendanceId = "attendance",
    DraftMeetingId = "draftMeeting",
    ServiceId = "service",
    ServicePriceId = "servicePrice",
    CustomFieldId = "customField",
    AvailabilityId = "availability",
    InPersonHostDefinedMeetingLocationId = "inPersonHostDefinedMeetingLocation",
    BookingId = "booking",
    CompanyCustomerId = "companyCustomer",
    AutomationId = "automation",
    App_IndexMeetings_Filter_ServiceId = "App_IndexMeetings_Filter_ServiceId",
    App_IndexMeetings_Filter_CompanyUserId = "App_IndexMeetings_Filter_CompanyUserId",
    App_IndexMeetings_Filter_MeetingState = "App_IndexMeetings_Filter_MeetingState",
    App_IndexMeetings_Filter_DateType = "App_IndexMeetings_Filter_DateType",
    App_IndexMeetings_Filter_MeetingStartAt = "App_IndexMeetings_Filter_MeetingStartAt",
    App_IndexMeetings_Filter_MeetingEndAt = "App_IndexMeetings_Filter_MeetingEndAt",
    App_IndexMeetings_Filter_Search = "App_IndexMeetings_Filter_Search",
    App_IndexRecurringMeetings_Filter_Search = "App_IndexRecurringMeetings_Filter_Search",
    App_IndexIntegrations_PreSelectedProvider = "provider",
    AvailableDates_TimeZone = "AvailableDates_TimeZone",
    AvailableDates_YearMonth = "AvailableDates_YearMonth",
    AvailableDates_DateInSelectedTimeZoneForDisplay = "AvailableDates_DateInSelectedTimeZoneForDisplay",
    AvailableDates_TimeSlotStartInSelectedTimeZoneForDisplay = "AvailableDates_TimeSlotStartInSelectedTimeZoneForDisplay",
    AvailableDates_TimeSlotEndInSelectedTimeZoneForDisplay = "AvailableDates_TimeSlotEndInSelectedTimeZoneForDisplay",
    AvailableDates_DateInAvailabilityTimeZoneForScheduling = "AvailableDates_DateInAvailabilityTimeZoneForScheduling",
    AvailableDates_TimeSlotStartInAvailabilityTimeZoneForScheduling = "AvailableDates_TimeSlotStartInAvailabilityTimeZoneForScheduling",
    AvailableDates_TimeSlotEndInAvailabilityTimeZoneForScheduling = "AvailableDates_TimeSlotEndInAvailabilityTimeZoneForScheduling",
    Customer_NewPassword_Token = "Customer_NewPassword_Token",
    Customer_Auth_RedirectUrl = "Customer_Auth_RedirectUrl",
}
